<template>
  <div class="uplaod">
    <div class="titleArea">
      <span v-if="info.isRequire" style="color: red">*</span>
      <span class="title">{{ info.fileTitle }}</span>
      <div class="format" v-if="!hideTip">
        注：<span v-if="info.tips">{{ info.tips }}</span>
        <span v-else>
          <span v-if="info.titleNotes">{{ info.titleNotes }}，</span>
          <span v-if="info.typeNotes">{{ info.typeNotes }}，</span>
          <span v-if="info.fileNumber">
            最多上传{{ info.fileNumber }}个文件，
          </span>
          <span v-if="info.fileSize">
            单个最大上传{{ info.fileSize }}M的文件
          </span>
        </span>
      </div>
    </div>
    <!-- <div class="tip">
      注：{{ info.typeNotes }}，最多上传{{ info.fileNumber }}个文件
    </div> -->
    <div class="uploadAction">
      <div>
        <div
          class="list"
          v-for="(item, index) in fileList"
          :key="index"
          @click="open(item)"
        >
          <div class="left">
            <img src="./imagas/changeState/doc.png" v-if="item.type == 'doc'" />
            <img src="./imagas/changeState/pdf.png" v-if="item.type == 'pdf'" />
            <img
              src="./imagas/changeState/excel.png"
              v-if="item.type == 'excel'"
            />
            <img src="./imagas/changeState/jpg.png" v-if="item.type == 'jpg'" />
            <img src="./imagas/changeState/zip.png" v-if="item.type == 'zip'" />
            <img src="./imagas/changeState/txt.png" v-if="item.type == 'txt'" />
            <div>
              <div class="name">{{ item.name }}</div>
              <div class="size">{{ item.size }}M</div>
            </div>
          </div>
          <img
            src="./imagas/changeState/remove.png"
            class="right"
            @click.stop="remove(item)"
          />
        </div>
      </div>
      <!-- {{ fileList[fileList.length - 1] }} -->
      <!-- <div class="desc" v-if="info.isInput === 1">
        <span>说明：</span
        ><a-input v-model="desc" @input="handelInput" style="width: 500px;" />
      </div> -->
      <a-upload
        name="file"
        :fileList="fileList"
        :accept="info.fileType"
        :multiple="true"
        :beforeUpload="beforeUpload"
        :action="`${axios.defaults.baseURL}/biz/archive/apply/upload `"
        :data="{
          configId: info.id,
          timeId: id,
        }"
        :headers="headers"
        :showUploadList="false"
        @change="handleChange"
        class="uploader"
      >
        <div class="uploadBtn">
          <img src="./imagas/changeState/upload.png" />
          <span>点击上传</span>
        </div>
      </a-upload>
    </div>
  </div>
</template>

<script>
import { checkFileType } from "../../../utils/util";
export default {
  data() {
    return {
      headers: { "X-Access-Token": localStorage.getItem("token") },
      desc: "",
      fileList: [],
    };
  },
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default: () => {},
    },
    hideTip: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: "",
    },
  },
  watch: {
    "info.fileList": {
      handler(val) {
        this.fileList = val.map((item) => {
          const obj = {
            uid: item.id,
            id: item.id,
            status: "done",
            size: item.fileSize,
            name: item.docName,
            url: item.docUrl,
            type: checkFileType(item.docUrl),
          };
          this.$emit("change", {
            configId: this.info.id,
            file: obj,
          });
          return obj;
        });
      },
      immediate: true,
    },
  },
  created() {
    if (this.info.isInput === 1) {
      this.desc = (this.info.fileList[0] || {}).remark || "";
    }
  },
  methods: {
    clearFiles() {
      this.fileList = [];
    },
    handleChange(info) {
      if (info.file.status === "done") {
        const index = this.fileList.findIndex(
          (item) => item.uid === info.file.uid
        );
        console.log(this.fileList);
        if (info.file.response.code === 200) {
          this.fileList[index].status = "done";
          this.fileList[index].url = info.file.response.result;
          this.fileList[index].type = checkFileType(info.file.response.result);
          console.log(this.fileList);
          this.$emit("change", {
            configId: this.info.id,
            file: this.fileList[index],
          });
          this.$message.success(`${info.file.name}上传成功`);
        } else {
          this.fileList[index].status = "error";
          this.fileList.splice(index, 1);
          this.$message.error(info.file.response.message);
        }
      } else if (info.file.status === "error") {
        const index = this.fileList.findIndex(
          (item) => item.uid === info.file.uid
        );
        this.fileList[index].status = "error";
        this.$message.error(`${info.file.name}上传失败`);
      }
    },
    beforeUpload(file) {
      if (this.info.fileSize) {
        const isLt2M = file.size / 1024 / 1024 < this.info.fileSize;
        if (!isLt2M) {
          this.$message.error(`只能上传小于${this.info.fileSize}MB的文档！`);
          return false;
        }
      }
      if (this.info.fileNumber) {
        if (this.fileList.length >= this.info.fileNumber) {
          this.$message.error("最多只能上传" + this.info.fileNumber + "个文件");
          return false;
        }
      }

      const type = file.name.split(".").pop().toLowerCase();
      if (!this.info.fileType || this.info.fileType.includes(type)) {
        this.fileList.push({
          uid: file.uid,
          status: "uploading",
          size: (file.size / 1024 / 1024).toFixed(2),
          name: file.name,
          url: "",
          type: null,
        });
        return true;
      } else {
        this.$message.error("上传文件格式错误");
        return false;
      }
    },
    remove(file) {
      const index = this.fileList.findIndex((item) => item.uid === file.uid);
      this.fileList.splice(index, 1);
      this.$emit("remove", {
        id: file.id,
        uid: file.uid,
      });
      // if (file.id) {
      //   this.$emit("remove", file.id);
      // }
    },
    handelInput() {
      this.$emit("changeDesc", {
        configId: this.info.id,
        desc: this.desc,
      });
    },
    open(item) {
      window.open(item.url, "_blank");
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';
.titleArea {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  .title {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 16px;
    color: #333333;
    margin-right: 10px;
  }
  .format {
    font-size: 14px;
    color: #999999;
  }
}
.uplaod {
  .uploadAction {
    display: flex;
    .list {
      width: 376px;
      height: 68px;
      background: #ffffff;
      border-radius: 10px;
      border: 1px solid #e5e9e9;
      margin-right: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;
      cursor: pointer;
      margin-bottom: 20px;
      .left {
        display: flex;
        align-items: center;
        img {
          widows: 26px;
          margin-right: 10px;
        }
        .name {
          font-family: PingFang-SC, PingFang-SC;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
          line-height: 18px;
        }
        .size {
          font-size: 14px;
          color: #b2b2b2;
          line-height: 18px;
        }
      }
      .right {
        width: 20px;
        height: 20px;
        cursor: pointer;
      }
    }
    .uploadBtn {
      width: 145px;
      height: 41px;
      background: $bgColor;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 15px;
      color: #ffffff;
      line-height: 36px;
      img {
        width: 15px;
        height: 18px;
        margin-right: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/docListUploadV2.vue